<template>
  <v-app>
    <app-bar />    
    <content-view />
  </v-app>
</template>

<script>
import AppBar from '../components/AppBar.vue'
import ContentView from '../components/ContentView.vue'

export default {
    name: 'Index',
    components: {
        AppBar: AppBar,       
        ContentView: ContentView
    }
}
</script>